import svg from 'component/svg';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { html } from '@resn/gozer-core';

import './index.scss';

const template = () => html`
    <div>
        <section class="noticeOverlay noticeOverlay--rotate">
            ${svg('x-logo', 'noticeOverlay__logo')}
            <h1 class="noticeOverlay__text text-heading6">Please rotate your device</h1>
        </section>
        <section class="noticeOverlay noticeOverlay--width">
            ${svg('x-logo', 'noticeOverlay__logo')}
            <h1 class="noticeOverlay__text text-heading6">Please increase the width of your browser.</h1>
        </section>
    </div>
`;

@componentMixin(DomComponentMixin)
class RotateOverlay extends Component {
    options = {
        template,
    };
}

export default RotateOverlay;
